import { fileResponseSchema, fileUploadUrlResponseSchema, fileReadUrlResponseSchema, } from '@consigli/types';
import { createTransformer, mapToSnakeCase } from './shared/base-api';
export const fileApiEndpoints = (builder, coreApiBaseUrl) => ({
    createFile: builder.mutation({
        query: ({ projectId, file }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/files/`,
            method: 'POST',
            body: mapToSnakeCase(file),
        }),
        invalidatesTags: ['Files'],
        transformResponse: createTransformer(fileResponseSchema, 'createFile'),
    }),
    updateFile: builder.mutation({
        query: ({ projectId, fileId, file }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/files/${fileId}/`,
            method: 'PATCH',
            body: mapToSnakeCase(file),
        }),
        invalidatesTags: ['Files', 'LayoutOptimizationResults', 'LayoutOptimizationFiles'],
        transformResponse: createTransformer(fileResponseSchema, 'updateFile'),
    }),
    getFile: builder.query({
        query: ({ projectId, fileId }) => `${coreApiBaseUrl}/projects/${projectId}/files/${fileId}/`,
        transformResponse: createTransformer(fileResponseSchema, 'getFile'),
    }),
    deleteFile: builder.mutation({
        query: ({ projectId, fileId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/files/${fileId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['Files'],
    }),
    getFileUploadUrl: builder.query({
        query: ({ projectId, fileId }) => `${coreApiBaseUrl}/projects/${projectId}/files/${fileId}/upload-url/`,
        transformResponse: createTransformer(fileUploadUrlResponseSchema, 'getFileUploadUrl'),
    }),
    getFileReadUrl: builder.query({
        query: ({ projectId, fileId }) => `${coreApiBaseUrl}/projects/${projectId}/files/${fileId}/read-url/`,
        providesTags: ['Files'],
        transformResponse: createTransformer(fileReadUrlResponseSchema, 'getFileReadUrl'),
    }),
});
